<template lang="pug">
  v-dialog(v-model="dialog" max-width="400" persistent)
    v-card(color="alternate" dark)
        br
        v-card-text {{message}}
            br
            br
            v-progress-linear(indeterminate color='white' class="mb-2")
</template>

<script>
import { mapGetters } from "vuex";
import service from "@/data/service";
import store from "@/store/index";

export default {
  //props: ["message"],
  data: () => ({
    dialog: false,
    message: "System starting up.."
  }),

  mounted() {
    if (this.standby) this.dialog = true;
    this.awake();
  },
  methods: {
    awake() {
      if (this.standby) {
        this.message += ".";
        setTimeout(() => {
          service.isAwake().then(() => {
            store.commit("onStandby", null);
            location.reload();
          });
          this.awake();
        }, 5000);
      }
    }
  },
  computed: {
    ...mapGetters(["standby"])
  }
};
</script>